<script setup lang="ts">
useSeoMeta({
  title: 'Cantook Access - Features',
  ogTitle: 'Cantook Access - Features',
  description:
    'Instant Image Extraction, Flexible Alternative Texts with AI, Team Collaboration, Support for Long Descriptions, Pay Only at Final Export, Simplified Accessibility Metadata Management',
  ogDescription:
    'Instant Image Extraction, Flexible Alternative Texts with AI, Team Collaboration, Support for Long Descriptions, Pay Only at Final Export, Simplified Accessibility Metadata Management',
});

const lang = useLocalStorage('CONTENT_LANG', 'en');

const { data: dataQueried } = await useAsyncData('pages-features-data', () =>
  queryCollection('features').all(),
);
const data = computed(
  () =>
    dataQueried.value?.find(
      (item) => item.title.toLowerCase() === lang.value?.toLowerCase(),
    )?.body,
);
</script>

<template>
  <div v-if="data">
    <FeaturesHero
      :hero="data.hero"
      :themeKeys="{
        bg: 'var(--color-slate-950)',
        title: 'var(--ui-text-inverted)',
        subtitle: 'var(--ui-text-inverted)',
        iconBg: 'var(--color-cantook-blue-100)',
        iconFg: 'var(--color-cantook-blue-500)',
        featureTitle: 'var(--ui-text-inverted)',
        featureDescription: 'var(--ui-text-inverted)',
      }"
    />
    <FeaturesCarroussel
      :carroussel="data.carroussel"
      :nextItemDelayMS="12 * 1000"
      :themeKeys="{
        bg: 'var(--color-white)',
        fg: 'var(--ui-text)',
        unselectedBg: 'var(--color-slate-100)',
        selectedBg: 'var(--color-cantook-blue-100)',
        selectedFg: 'var(--color-cantook-blue-500)',
      }"
    />
    <FeaturesList
      :list="data.featureList"
      :themeKeys="{
        bg: 'var(--color-white)',
        title: 'var(--ui-text)',
        features: 'var(--ui-text-toned)',
      }"
    />
    <FeaturesFAQ
      :faq="data.faq"
      :themeKeys="{
        bg: 'var(--color-cantook-blue-600)',
        title: 'var(--ui-text-inverted)',
        subtitle: 'var(--ui-text-inverted)',
        question: 'var(--ui-text-inverted)',
        answer: 'var(--ui-text-inverted)',
        iconBg: 'var(--color-white)',
        iconFg: 'var(--color-slate-950)',
      }"
    />
  </div>
</template>
